import { useContext } from "react";

import { CreateTemplateContext, ICreateTemplateContext } from "context/TemplateProvider";

const useCreateTemplateContext = (): ICreateTemplateContext => {
    const context = useContext(CreateTemplateContext);
    return context;
}

export default useCreateTemplateContext;